interface ConditionalWrapperInterface {
    condition: boolean
    wrapper: (children: JSX.Element) => JSX.Element
    children: JSX.Element
}

export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperInterface) => (condition ? wrapper(children) : children)
